export default __webpack_public_path__ + "static/media/edward-logo-closed.74af095d.png";